<div class="puntos-venta-wapper-desktop" [ngClass]="{'puntos-venta-wapper-desktop-cool': modeGroup}">
  @if (load) {
    <div class="header-desktop" [ngClass]="{'header-desktop-cool': modeGroup}">
      <div class="icon">
        <img (click)="back()" src="/assets/images/icons/header/arrow-left.svg" alt="img"/>
      </div>
      <h4>{{numeroSearch}}</h4>
    </div>
  }
  <app-puntos-venta-list (loadEv)="load=true"></app-puntos-venta-list>
</div>